<!-- Gemello di select-pdf-style-dialog.component.html: cambiano solo la riga
     dell'esito e il pulsante finale (vedere invece di scaricare). Condividono
     lo stesso SCSS. -->
<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <div class="izy-ready-box izy-sharp-bl">
    <mat-icon class="izy-ready-icon">content_paste_go</mat-icon>
    <p class="izy-ready-message">Documento pronto per l'anteprima</p>
  </div>

  @if (data.message) {
    <p class="izy-ready-hint">{{ data.message }}</p>
  }

  <!-- .izy-fields (styles.scss) da' al campo il contorno nero 2px e il raggio
       16px dei form dell'app; .izy-select-trigger / .izy-select-panel--form
       sono la freccetta che ruota e il pannello bordato nero degli altri
       select di form. -->
  <div class="izy-fields">
    <mat-form-field appearance="outline" class="izy-style-field">
      <mat-label>Seleziona stile PDF</mat-label>
      <mat-select
        [(value)]="selectedStyle"
        class="izy-select-trigger"
        panelClass="izy-select-panel izy-select-panel--form">
        <mat-option value="style1">
          <span class="izy-style-dot izy-style-dot--primary"></span>
          Stile 1 - Semplice
        </mat-option>
        <mat-option value="style2">
          <span class="izy-style-dot izy-style-dot--info"></span>
          Stile 2 - Moderno
        </mat-option>
        <mat-option value="style3">
          <span class="izy-style-dot izy-style-dot--warn"></span>
          Stile 3 - Raffinato
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    (click)="closeDialog()"
    class="izy-button-ghost custom-button-border">
    <mat-icon>close</mat-icon>
    Chiudi
  </button>

  <button
    matButton="filled"
    type="button"
    (click)="downloadPdf()"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>visibility</mat-icon>
    Vedi PDF
  </button>
</mat-dialog-actions>
